import { AuthClient } from "@/utils/client";

export const deleteAccount = (data: {
  email: string;
  reason: string;
  honeyPot?: string;
}) => {
  return AuthClient().post(`/common/delete-account`, data);
};
